declare const __API_URL__: string;
declare const __PRODUCTION__: boolean;
declare const __VERSION__: string;
declare const __COMMITHASH__: string;
declare const __BRANCH__: string;
declare const __LASTCOMMITDATETIME__: string;


export const VERSION = __VERSION__;
export const APIURL = __API_URL__;
export const COMMITHASH = __COMMITHASH__;